import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class TaskService {

  static createTask(payload) {
    return HttpUtil.post(API_ROUTES.TASK.CREATE_TASK, payload);
  }

  static updateTask(taskId, payload) {
    return HttpUtil.put(API_ROUTES.TASK.UPDATE_TASK.replace("<taskId>", taskId), payload);
  }

  static getTask(taskId) {
    return HttpUtil.get(API_ROUTES.TASK.GET_TASK.replace("<taskId>", taskId), {});
  }

  static listTasks(
    pageNumber = 0,
    pageSize = 10,
    regulationCode = "",
    companyId = "",
    key = "",
    sort = "",
  ) {
    return HttpUtil.get(
      API_ROUTES.DASHBOARD.LISTTASKS.replace("<pageSize>", pageSize)
        .replace("<pageNumber>", pageNumber)
        .replace(regulationCode ? "<regulationCode>" : "&regulationCode=<regulationCode>", regulationCode)
        .replace(companyId ? "<companyId>" : "&companyId=<companyId>", companyId)
        .replace("<key>", key)
        .replace("<sort>", sort)
    );
  }
}
